import { BASE_URL } from 'src/components/10-atoms/seo/constants';
export function getEPHomeCanonical(examLevelID) {
    if (examLevelID) {
        return `exam-prep/?examLevelID=${examLevelID}`;
    }
    return 'exam-prep/';
}
export function getEPHomeUrl(examLevelID) {
    return `${BASE_URL}/${getEPHomeCanonical(examLevelID)}`;
}
